export default __webpack_public_path__ + "e08c2417bbb4594a3c15991c55d997e0.png";